import styled from "styled-components";
import { Logo } from "./Logo";

const Container = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
`;

export function Loading() {
    return (
        <Container>
            <Logo />
        </Container>
    );
}
